export const ADMINISTRADOR = 'Administrador';
export const MARKETING = "Marketing";
export const CAPITAL_HUMANO = "Capital humano";

export const ADMINISTRADOR_ID = 1;
export const MARKETING_ID = 2;
export const CAPITAL_HUMANO_ID = 3;
